// apps/web/src/i18n/de.ts — German resource bundle.

export const deResources = {
  greeting: "Hallo Gastio",
  toggle: "DE/EN",
  reservationCta: "Tisch reservieren",
  nav: {
    brand: "Gastio",
    tabHeute: "Heute",
    tabReservierungen: "Reservierungen",
    tabKalender: "Kalender",
    tabEinstellungen: "Einstellungen",
  },
  auth: {
    login: {
      title: "Personal-Login",
      subhead: "Ristorante Esempio · Verwaltung",
      email: "E-Mail",
      password: "Passwort",
      submit: "Anmelden",
      loading: "Wird angemeldet…",
      roleHint:
        "Zugriff je nach Rolle: Administrator, Service oder Leseberechtigung.",
    },
    errors: {
      invalidCredentials: "E-Mail oder Passwort ist falsch.",
      accountLocked:
        "Konto vorübergehend gesperrt. Bitte in 15 Minuten erneut versuchen.",
      csrfMismatch: "Sitzung abgelaufen. Bitte erneut anmelden.",
      refreshTokenReused:
        "Sitzung aus Sicherheitsgründen beendet. Bitte erneut anmelden.",
      unauthenticated: "Nicht angemeldet.",
      forbidden: "Keine Berechtigung.",
      network: "Verbindung fehlgeschlagen. Bitte erneut versuchen.",
    },
  },
  settings: {
    placeholder: "Einstellungen — Phase 2 Platzhalter",
    logout: "Abmelden",
    hub: {
      title: "Einstellungen",
      sectionReservierung: "Reservierung",
      sectionBetrieb: "Betrieb",
      sectionBald: "Bald verfügbar",
      rowHours: "Öffnungs- & Reservierungszeiten",
      rowAvailability: "Verfügbarkeit",
      rowRestaurantProfile: "Restaurant-Profil",
      rowSlots: "Zeitslots & Tischdauer",
      rowCapacity: "Kapazität (pro Tag & Slot)",
      rowLeadTime: "Vorausbuchung & Mindestvorlauf",
      rowSameDayCutoff: "Same-Day-Annahmeschluss",
      rowMinMax: "Min/Max Personen",
      rowAreas: "Bereiche (Innen/Terrasse)",
      rowBlocked: "Geblockte Zeiträume / Ferien",
      rowConfirmation: "Bestätigung: automatisch / manuell",
      rowRetention: "DSGVO: Löschfrist",
      rowUsers: "Benutzer & Rollen",
      // Quick-Task 260920-u3p: hub link to the admin account page
      // (self-service email change).
      rowAccount: "Konto",
      rowWaitlist: "Warteliste",
      rowStats: "Statistiken (Auslastung, Storno, No-Show)",
      rowTables: "Tischverwaltung",
      rowMultiTenant: "Multi-Mandant / Filialen",
      tagActive: "Aktiv",
      tagBald: "Bald",
      backToHub: "Zurück zur Übersicht",
    },
    restaurant: {
      nameLabel: "Restaurantname",
      slotDurationLabel: "Slot-Dauer (Minuten)",
      capacityLabel: "Standardkapazität (Plätze pro Tag)",
      holdbackLabel: "Holdback (Plätze pro Tag)",
      addressLabel: "Adresse",
      postalLabel: "PLZ",
      cityLabel: "Stadt",
      phoneLabel: "Telefon",
      emailLabel: "E-Mail",
      contactNotesLabel: "Notiz für Gäste",
      taglineLabel: "Tagline (DE/EN)",
      heroCopyLabel: "Hero-Text (DE/EN)",
      aboutTextLabel: "Über uns (DE/EN)",
      save: "Speichern",
      cancel: "Abbrechen",
      saved: "Gespeichert.",
      saveError: "Speichern fehlgeschlagen.",
    },
    // Quick-Task 260920-u3p: admin self-service email-change form.
    // Keys consumed by apps/web/src/pages/admin/account.tsx. Keep
    // parity with en.ts — apps/web/src/i18n/admin-parity.test.ts
    // scans both bundles.
    account: {
      title: "Konto",
      description:
        "Ändern Sie die E-Mail-Adresse Ihres Admin-Kontos. Wir senden einen Bestätigungslink an die neue Adresse.",
      currentEmailLabel: "Aktuelle E-Mail",
      newEmailLabel: "Neue E-Mail",
      newEmailPlaceholder: "ihre.neue.adresse@beispiel.de",
      submit: "Bestätigungs-Link senden",
      requestSent:
        "Bestätigungs-Link wurde an {{newEmail}} gesendet. Prüfen Sie auch den Spam-Ordner.",
      errorSameEmail:
        "Die neue E-Mail muss sich von der aktuellen unterscheiden.",
      errorEmailTaken:
        "Diese E-Mail-Adresse ist bereits vergeben oder wird gerade geprüft.",
      errorRateLimited:
        "Zu viele Anfragen — versuchen Sie es in 24 Stunden erneut.",
      errorGeneric:
        "Die Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
    },
    hours: {
      title: "Öffnungs- & Reservierungszeiten",
      tzLabel: "(Europe/Berlin)",
      weekdayMo: "Mo",
      weekdayTu: "Di",
      weekdayWe: "Mi",
      weekdayTh: "Do",
      weekdayFr: "Fr",
      weekdaySa: "Sa",
      weekdaySu: "So",
      closed: "Geschlossen (Ruhetag)",
      ruhetag: "Ruhetag",
      addException: "+ Manuelle Ausnahme hinzufügen",
      exceptionTitle: "Ausnahme hinzufügen",
      exceptionEditTitle: "Ausnahme bearbeiten",
      exceptionDate: "Datum",
      exceptionStatusClosed: "Ruhetag (geschlossen)",
      exceptionStatusCustom: "Andere Zeiten",
      exceptionTimeRange: "{{openTime}} – {{closeTime}}{{nextDay}}",
      exceptionOpen: "Öffnungszeit",
      exceptionClose: "Schließzeit",
      exceptionCloseNextDay: "Schließt am Folgetag",
      exceptionSave: "Speichern",
      exceptionCancel: "Abbrechen",
      exceptionEdit: "Ausnahme bearbeiten",
      exceptionDelete: "Ausnahme löschen",
      exceptionDeleteConfirm: "Ausnahme am {{date}} wirklich löschen?",
      exceptionLoadError: "Ausnahme konnte nicht geladen werden.",
      empty: "Noch keine Ausnahmen definiert.",
      saved: "Gespeichert.",
      saveError: "Speichern fehlgeschlagen.",
      preview: "Vorschau: {{range}} (Europe/Berlin)",
    },
    // Phase 6 quick-task 260916-bf6: per-restaurant notification
    // provider config (Brevo + SMTP) + reminder cadence + admin
    // locale. Keys mirror the form fields so the Admin UI can be
    // translated without touching component code.
    notifications: {
      title: "Benachrichtigungen",
      sectionEmail: "E-Mail-Provider",
      sectionSms: "SMS-Provider",
      sectionReminder: "Erinnerung & Admin-Sprache",
      save: "Speichern",
      saveSuccess: "Änderungen gespeichert.",
      saveFailure:
        "Änderungen konnten nicht gespeichert werden. Bitte Eingaben prüfen und erneut versuchen.",
      email: {
        helper:
          "Pro Restaurant eigener Absender. SMTP-Passwort und Brevo-API-Key werden nie im Klartext zurückgegeben.",
        providerSmtp: "SMTP",
        providerBrevo: "Brevo",
        host: "SMTP-Host",
        port: "SMTP-Port",
        from: "Absenderadresse (From)",
        username: "SMTP-Benutzername (optional)",
        password: "SMTP-Passwort (wird nicht angezeigt)",
        passwordHint:
          "Aktueller Status: {{status}} — leeres Feld = Passwort unverändert lassen.",
        // simplify-brevo-sender-config: per-restaurant Brevo sender
        // fields are gone — sender identity is now derived from
        // Restaurant.name + Restaurant.email at send time. The
        // brevoSenderEmail / brevoSenderName / brevoReplyTo /
        // brevoApiKeyHint keys are intentionally no longer
        // surfaced in the UI.
        tokenSet: "konfiguriert",
        tokenMissing: "fehlt",
        errors: {
          hostRequired: "SMTP-Host darf nicht leer sein.",
          portRange: "SMTP-Port muss eine Ganzzahl zwischen 1 und 65535 sein.",
          fromInvalid: "Absenderadresse muss eine gültige E-Mail-Adresse sein.",
        },
      },
      sms: {
        helper:
          "Optionaler HTTP-Webhook für SMS-Erinnerungen. Token wird nie im Klartext zurückgegeben.",
        url: "Webhook-URL",
        token: "Bearer-Token (wird nicht angezeigt)",
        tokenHint: "Aktueller Status: {{status}}.",
        errors: {
          urlInvalid:
            "Webhook-URL muss eine gültige URL sein (oder leer bleiben, um SMS zu deaktivieren).",
        },
      },
      reminder: {
        helper:
          "Gäste erhalten eine Erinnerung so viele Stunden vor dem reservierten Slot. Admin-Sprache steuert die deutsche oder englische Version der Buchungsbestätigung.",
        hours: "Stunden vor dem Termin (1–168)",
        locale: "Sprache der Buchungs-E-Mails",
        localeDe: "Deutsch",
        localeEn: "Englisch",
        errors: {
          range:
            "Erinnerungsfenster muss eine Ganzzahl zwischen 1 und 168 Stunden sein.",
        },
      },
    },
  },
  // Phase 03 plan 03-03: admin availability surface i18n bundle.
  // Every key in `availability` exists in both de.ts and en.ts with
  // parallel shape (parity test in apps/web/src/i18n/availability.test.ts).
  availability: {
    admin: {
      title: "Verfügbarkeit",
      sectionSlots: "Zeitslots",
      sectionCapacity: "Kapazität & Holdbacks",
      sectionBlockedPeriods: "Gesperrte Zeiträume",
      sectionBookingRules: "Buchungsregeln",
      slot: {
        add: "Slot hinzufügen",
        save: "Slot speichern",
        cancel: "Abbrechen",
        deleteArmed:
          "Slot {{time}} löschen? Dies kann nicht rückgängig gemacht werden.",
        deleteConfirm: "Slot löschen",
        empty: "Noch keine Zeitslots definiert. Legen Sie den ersten Slot an.",
        weekdayMo: "Mo",
        weekdayTu: "Di",
        weekdayWe: "Mi",
        weekdayTh: "Do",
        weekdayFr: "Fr",
        weekdaySa: "Sa",
        weekdaySo: "So",
        startTime: "Start (HH:mm)",
        duration: "Dauer (Min.)",
        active: "Aktiv",
        weekdayBinding: "Wochentage",
        capacityOverride: "Kapazitäts-Override",
        holdbackOverride: "Holdback-Override",
        standardOverride: "Standard",
        edit: "Slot bearbeiten",
        delete: "Slot löschen",
        cancelDelete: "Abbrechen",
      },
      capacity: {
        scopeStandard: "Standard",
        scopeDate: "Datum",
        scopeSlot: "Slot",
        scopeDateSlot: "Datum + Slot",
        columnTotal: "Gesamt",
        columnOnline: "Online-Holdback",
        columnPhone: "Telefon-Holdback",
        columnWalkIn: "Vor-Ort-Holdback",
        columnAvailable: "Verfügbar (Online)",
        helper:
          "Alle nicht stornierten Reservierungen zählen zur gemeinsamen Kapazität. Holdbacks reservieren Plätze pro Kanal.",
        // Quick 260831-q3h: clarifies that an empty Gesamt input means
        // "use Restaurant.capacityDefault" (= {{default}}).
        helperTotal:
          "Leer lassen, um die Restaurant-Standardkapazität zu verwenden ({{default}}).",
        save: "Kapazität speichern",
        pickDate: "Datum wählen",
        pickSlot: "Slot wählen",
        noOverride: "Kein Override",
        defaultCapacity: "Standardkapazität",
      },
      blockedPeriod: {
        add: "Zeitraum sperren",
        allDay: "Ganztägig",
        partialDay: "Uhrzeit begrenzen",
        fromDate: "Von (Datum)",
        toDate: "Bis (Datum)",
        fromTime: "Von (HH:mm)",
        toTime: "Bis (HH:mm)",
        reason: "Begründung (öffentlich)",
        save: "Zeitraum sperren",
        cancel: "Abbrechen",
        deleteArmed:
          "Zeitraum {{range}} löschen? Die Tage werden wieder nach den übrigen Regeln bewertet.",
        deleteConfirm: "Zeitraum löschen",
        empty: "Noch keine gesperrten Zeiträume.",
        rolloverError:
          "Die Endzeit muss nach der Startzeit liegen. Zeiträume über Mitternacht werden hier nicht unterstützt.",
        dateRangeError: "Das Enddatum darf nicht vor dem Startdatum liegen.",
        timeRangeError: "Die Endzeit muss nach der Startzeit liegen.",
        conflictTitle:
          "Es gibt {{count}} betroffene Reservierungen am gewählten Tag.",
        conflictAck:
          "Betroffene Gäste wurden informiert und die Reservierungen storniert.",
        conflictConfirm: "Blocken bestätigen",
      },
      rules: {
        maxAdvanceDays: "Max. Vorausbuchungstage",
        minAdvanceMinutes: "Mindestvorlauf (Minuten)",
        sameDayCutoff: "Annahmeschluss (gleicher Tag)",
        minPartySize: "Min. Personenzahl",
        maxPartySize: "Max. Personenzahl",
        save: "Buchungsregeln speichern",
        confirmationModeAuto: "Automatisch bestätigen",
        confirmationModeManual: "Manuell anfragen",
        confirmationModeLabel: "Bestätigungsmodus",
        advancedWindowHint:
          "Gäste können maximal {{days}} Tage im Voraus buchen.",
        sameDayCutoffHint:
          "Späteste Uhrzeit, zu der eine Reservierung für den heutigen Tag noch angenommen wird.",
      },
    },
    actions: {
      saveSuccess: "Änderungen gespeichert.",
      saveFailure:
        "Änderungen konnten nicht gespeichert werden. Prüfen Sie die Eingaben und versuchen Sie es erneut.",
    },
    errors: {
      dayBlocked: "Dieser Tag ist gesperrt.",
      slotFull: "Dieser Slot ist ausgebucht.",
      outsideAdvanceWindow: "Außerhalb des Buchungsfensters.",
      outsideSameDayCutoff: "Annahmeschluss für heute bereits überschritten.",
      invalidPartySize: "Personenzahl außerhalb des erlaubten Bereichs.",
      unexpected: "Ein unerwarteter Fehler ist aufgetreten.",
    },
    // Phase 03 plan 03-04: guest web surface (A2·B date agenda + A3 slot picker).
    // Every key in `availability.calendar` and `availability.slot` exists in
    // both de.ts and en.ts with parallel shape.
    calendar: {
      wizardMeta: "Schritt 1 von 6 · Datum",
      heading: "Datum wählen",
      prevMonth: "Vorheriger Monat",
      nextMonth: "Nächster Monat",
      loading: "Verfügbarkeit wird geladen",
      error:
        "Verfügbarkeit konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
      retry: "Erneut versuchen",
      emptyFilter: "Für diesen Filter gibt es in diesem Monat keine Termine.",
      noAvailableDates:
        "In diesem Monat gibt es keine verfügbaren Termine. Wählen Sie einen anderen Monat.",
      tabAvailable: "Verfügbar",
      tabFull: "Ausgebucht",
      tabBlocked: "Gesperrt",
      tabPast: "Vergangen",
      tabOutsideWindow: "Außerhalb Buchungsfenster",
      rowAvailable_one: "{{count}} freie Zeit",
      rowAvailable_other: "{{count}} freie Zeiten",
      rowFull: "Keine freien Zeiten",
      rowBlocked: "Gesperrt · {{reason}}",
      rowBlockedNoReason: "Gesperrt",
      rowPast: "Nicht mehr buchbar",
      rowOutsideWindow: "Außerhalb des Buchungsfensters",
    },
    slot: {
      wizardMeta: "Schritt 2 von 6 · Zeit",
      heading: "Uhrzeit wählen",
      back: "Zurück zur Datumsauswahl",
      cta: "Zeit auswählen",
      ctaPending: "Zeit wird übernommen…",
      empty: "Keine buchbaren Zeiten",
      emptyBody:
        "Für dieses Datum sind keine buchbaren Zeiten verfügbar. Wählen Sie ein anderes Datum.",
      remaining_one: "{{count}} Platz frei",
      remaining_other: "{{count}} Plätze frei",
      cutoffHint:
        "Nicht angezeigte Zeiten liegen außerhalb des Mindestvorlaufs oder Annahmeschlusses.",
      staleCleared:
        "Die gewählte Uhrzeit ist nicht mehr verfügbar. Wählen Sie eine andere Zeit.",
    },
  },
  // Phase 03 plan 03-04: shared wizard progress segment labels (date/slot pages).
  reservation: {
    wizard: {
      step1: "Datum",
      step2: "Zeit",
      step3: "Personen",
      step4: "Kontakt",
      step5: "Übersicht",
      step6: "Bestätigung",
      progressAria: "Buchungsfortschritt, Schritt {{current}} von {{total}}",
    },
  },
  // Phase 5 plan 05-04 + 260801-w8s: top-level status.* / source.* keys
  // consumed by StatusTag + SourceTag in apps/web/src/pages/admin/shared/.
  // Keys mirror the uppercase GraphQL enum values returned by the admin API.
  status: {
    BESTAETIGT: "Bestätigt",
    ANGEFRAGT: "Anfrage",
    ANGEKOMMEN: "Angekommen",
    NO_SHOW: "Nicht erschienen",
    STORNIERT: "Storniert",
  },
  source: {
    ONLINE: "Online",
    TELEFON: "Telefon",
    VOR_ORT: "Vor Ort",
  },
  // Phase 5 admin namespace. Bundled per page so the keys cluster
  // around their consumer. Parity: every leaf must exist in en.ts too.
  admin: {
    today: {
      pageTitle: "Heute",
      layout: {
        label: "Ansicht wählen",
        list: "Liste",
        timeline: "Tagesablauf",
      },
      bottomCta: {
        telefon: "Telefonische Reservierung",
        vorOrt: "Vor Ort anlegen",
      },
      capacityBar: {
        booked: "Gebucht",
        holdback: "Zurückgehalten",
      },
      sortChips: {
        label: "Sortieren",
        time: "Uhrzeit",
        name: "Name",
        party: "Personen",
      },
      emptyState: {
        headline: "Keine Reservierungen heute",
        ctaLabel: "Manuelle Reservierung anlegen",
      },
      // Quick 260831-q3h: trailing reservation-number annotation on
      // each timeline row (TodayTimelineView). The previous code looked
      // up a non-existent key, so the raw path "admin.today.reservationNumber"
      // leaked through the UI.
      reservationNumber: "Nr. {{number}}",
    },
    reservations: {
      pageTitle: "Reservierungen",
      header: {
        manualCreate: "Manuell anlegen",
      },
      datePicker: {
        prevDay: "Vorheriger Tag",
        nextDay: "Nächster Tag",
        today: "Heute",
        blockDay: "Tag sperren",
      },
      search: {
        placeholder: "Suchen…",
        scopeNotice: "Suche läuft über alle Tage ({{date}} ist nicht wirksam).",
        scopeReset: "Zurück zum {{date}}",
      },
      filters: {
        title: "Filter",
        status: "Status",
        source: "Quelle",
        apply: "Anwenden",
        clear: "Zurücksetzen",
      },
      empty: "Keine Reservierungen gefunden.",
      loadMore: "Mehr laden",
      row: {
        edit: "Bearbeiten",
        cancel: "Stornieren",
        // Quick 260831-q3h: inline status-transition buttons for the
        // 5-state machine (D-06 / D-07). Bestätigen = ANGEFRAGT →
        // BESTAETIGT (Anfrage bestätigen). Angekommen + No-Show
        // appear once a reservation is Bestätigt (or, for No-Show,
        // even after Angekommen).
        confirm: "Bestätigen",
        markArrived: "Angekommen",
        markNoShow: "No-Show",
        internalNoteLabel: "Interne Notiz",
      },
      errors: {
        notFound: "Reservierung nicht gefunden.",
      },
      // Phase 6 plan 06-04 (EXP-01..03): admin-only CSV/PDF export.
      // Two buttons (CSV + PDF) next to the existing filter row; each
      // downloads a file with 11 columns of reservation data (incl.
      // PII). One-time-use download token, 5-minute TTL, audit-logged.
      export: {
        button: "Exportieren",
        format: {
          csv: "CSV",
          pdf: "PDF",
        },
        fromDate: "Von",
        toDate: "Bis",
        success: "Export wird heruntergeladen…",
        error: "Export fehlgeschlagen",
      },
    },
    reservationEdit: {
      pageTitle: "Reservierung bearbeiten",
      notAuthorized: "Keine Berechtigung zum Bearbeiten.",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      partySize: "Personenzahl",
      internalNote: "Interne Notiz",
      save: "Speichern",
      cancel: "Abbrechen",
    },
    manualCreate: {
      pageTitle: "Manuelle Reservierung",
      sourceLabel: "Quelle",
      sourceTelefon: "Telefon",
      sourceVorOrt: "Vor Ort",
      dateLabel: "Datum",
      timeLabel: "Uhrzeit",
      partySizeLabel: "Personen",
      nameLabel: "Name",
      emailOptional: "E-Mail (optional)",
      phoneOptional: "Telefon (optional)",
      internalNoteLabel: "Interne Notiz",
      capacityWarning: "Kapazität wird überschritten.",
      cutoffWarning: "Außerhalb des Annahmeschlusses.",
      forceConfirm: "Trotzdem anlegen",
      submit: "Reservierung anlegen",
    },
    calendar: {
      pageTitle: "Kalender",
      monthNav: {
        prev: "Vorheriger Monat",
        next: "Nächster Monat",
      },
      blockedRanges: {
        title: "Gesperrte Zeiträume",
        edit: "Bearbeiten",
        delete: "Löschen",
        confirmDelete:
          "Zeitraum wirklich löschen? Die Tage werden wieder normal bewertet.",
        empty: "Noch keine Zeiträume gesperrt.",
      },
      capacityFooter: {
        title: "Tageskapazität",
        booked: "Gebucht",
        capacity: "Kapazität",
        holdback: "Zurückgehalten",
        remaining: "Verfügbar (Online)",
      },
      dayTap: {
        unblockTitle: "Tag freigeben?",
        unblockConfirm: "Freigeben",
        unblockCancel: "Abbrechen",
        unblockSuccess: "Tag wurde freigegeben.",
        blockTitle: "Tag blockieren",
        blockSuccess: "Tag wurde blockiert.",
        errorFallback: "Ein unerwarteter Fehler ist aufgetreten.",
      },
    },
  },
  // Phase 4 plan 04-03: guest wizard A4..A7 (slot picker, contact,
  // consent, review, submit, confirmation). The 6-step progress
  // segments above are unchanged — A4..A7 is the second half of the
  // 6-step flow.
  wizard: {
    a4: {
      title: "Datum wählen",
      subtitle: "Wähle einen verfügbaren Zeitpunkt",
      back: "Zurück",
      next: "Weiter",
      meta: "Schritt 4 von 6 · Zeitpunkt",
      empty: "Keine verfügbaren Zeitpunkte für dieses Datum",
      retry: "Erneut versuchen",
      errorMessage:
        "Die Zeitpunkte konnten nicht geladen werden. Bitte versuche es erneut.",
      loading: "Verfügbare Zeiten werden geladen",
      tooltip: {
        blocked: "Reservierungen aktuell nicht möglich",
        full: "Zeitpunkt ausgebucht",
        outsideBookingHours: "Außerhalb der Öffnungszeiten",
      },
      errors: {
        empty: "Bitte wähle einen Zeitpunkt aus",
        invalid: "Zeitpunkt ungültig",
      },
    },
    a5: {
      title: "Deine Kontaktdaten",
      subtitle:
        "Wir benötigen deinen Namen und mindestens eine Kontaktmöglichkeit",
      nameLabel: "Vor- und Nachname",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon",
      consentLabel: "Ich stimme der Verarbeitung meiner Daten zu",
      back: "Zurück",
      next: "Weiter",
      errors: {
        nameRequired: "Bitte gib deinen Namen an",
        nameTooLong: "Name darf maximal 120 Zeichen lang sein",
        emailInvalid: "Bitte gib eine gültige E-Mail an",
        phoneInvalid: "Bitte gib eine gültige Telefonnummer an",
        contactRequired:
          "Bitte gib mindestens eine E-Mail oder Telefonnummer an",
        consentRequired: "Bitte stimme der Datenverarbeitung zu",
        consentEmpty: "Datenschutztext nicht verfügbar",
      },
    },
    a6: {
      title: "Prüfe deine Reservierung",
      subtitle:
        "Bitte überprüfe alle Angaben, bevor du verbindlich reservierst",
      back: "Zurück",
      submit: "Verbindlich reservieren",
      submitManual: "Anfrage senden",
      manualNote:
        "Deine Anfrage wird vom Restaurant bestätigt. Du erhältst eine Bestätigung per E-Mail.",
      submitting: "Wird gesendet…",
      summary: {
        date: "Datum",
        time: "Uhrzeit",
        duration: "Dauer",
        party: "Personen",
        contact: "Kontakt",
        consent: "Datenschutzhinweis",
      },
      errors: {
        invalidDate: "Datum ungültig",
        invalidSlot: "Slot ungültig",
        partySize: "Personenzahl ungültig",
        invalidArea: "Bereich ungültig",
      },
    },
    a7: {
      title: "Reservierung bestätigt",
      titleManual: "Anfrage eingegangen",
      reservationNumberLabel: "Bestätigungsnummer",
      selfServiceLabel: "Link zur Selbstverwaltung",
      copyLink: "Link kopieren",
      linkCopied: "Kopiert",
      tokenExpiresAt: "Gültig bis {{date}}",
      tokenExpiresCaption:
        "Der Link ist 24 Stunden gültig. Bewahre ihn gut auf, um deine Reservierung später einsehen, ändern oder stornieren zu können.",
      fallbackTitle:
        "Diese Seite ist nur direkt nach einer Reservierung erreichbar",
      fallbackBody: "Bitte über den Link in deiner Bestätigungs-E-Mail.",
      nextActions: "Was möchtest du als Nächstes tun?",
      manageAction: "Reservierung verwalten",
      newAction: "Neue Reservierung",
      home: "Zur Startseite",
      partySize_one: "{{count}} Person",
      partySize_other: "{{count}} Personen",
      dateTime: "{{date}} um {{time}}",
    },
    // Phase 4 plan 04-04: self-service surface (A8 read view).
    a8: {
      title: "Deine Reservierung",
      subtitle:
        "Hier kannst du deine Reservierung einsehen, ändern oder stornieren",
      status: {
        label: "Status",
        confirmed: "Bestätigt",
        requested: "Anfrage eingegangen",
        cancelled: "Storniert",
        noShow: "Nicht erschienen",
      },
      confirmationMode: {
        label: "Bestätigungsmodus",
        auto: "Automatisch bestätigt",
        manual: "Auf Bestätigung wartend",
      },
      actions: {
        modify: "Reservierung ändern",
        cancel: "Reservierung stornieren",
      },
      disabledReason:
        "Änderungen und Stornierungen sind nur bis 60 Minuten vor dem Termin möglich.",
      tokenInvalid:
        "Dieser Link ist nicht mehr gültig. Bitte kontaktiere das Restaurant, um deine Reservierung zu verwalten.",
      loading: "Lade Reservierung…",
      footer:
        "Diese Seite ist nur über den Link in deiner Bestätigungs-E-Mail erreichbar.",
    },
    // Phase 4 plan 04-04: A9 modify + A10 cancel + A11 cancelled.
    a9: {
      title: "Reservierung ändern",
      subtitle: "Wähle einen neuen Zeitpunkt",
      step1: "Neuer Zeitpunkt",
      step2: "Name",
      back: "Zurück",
      next: "Weiter",
      submit: "Änderung bestätigen",
      submitting: "Wird gesendet…",
      success: "Deine Reservierung wurde aktualisiert.",
      errorExpired:
        "Diese Reservierung kann nicht mehr geändert oder storniert werden.",
      errorNameRequired: "Bitte gib deinen Namen an",
      errorNameTooLong: "Name darf maximal 120 Zeichen lang sein",
    },
    a10: {
      title: "Reservierung stornieren",
      subtitle: "Möchtest du deine Reservierung wirklich stornieren?",
      reasonLabel: "Optional: Grund der Stornierung",
      confirmLabel: "Ja, ich möchte stornieren",
      submit: "Stornierung bestätigen",
      submitting: "Wird gesendet…",
      errorConfirmRequired:
        "Bitte bestätige die Stornierung durch Anhaken der Checkbox.",
    },
    a11: {
      title: "Deine Reservierung wurde storniert",
      body: "Du erhältst in Kürze eine Bestätigung per E-Mail.",
      newAction: "Neue Reservierung",
    },
    // Phase 4 follow-up #2: the /reservierung/:token catch-all also
    // catches obvious non-tokens like /reservierung/datum when the
    // user types the wizard-verb by mistake. We pre-validate the URL
    // parameter against the token shape (32 chars, base64url) before
    // firing the API; misses render this card instead of the misleading
    // "Link nicht mehr gültig" tokenInvalid copy (which implied the
    // guest's real link had expired).
    notFound: {
      title: "Seite nicht gefunden",
      body: "Der angegebene Link existiert nicht. Wenn du eine Reservierung verwalten möchtest, öffne den Link aus deiner Bestätigungs-E-Mail.",
      home: "Zur Startseite",
    },
  },
  // Phase 4 plan 04-03: server-error message keys. The A6 page reads
  // `error.extensions.messageKey` first, then falls back to a
  // code-based mapping in `wizard/validation.ts`.
  errors: {
    slotFull:
      "Dieser Zeitpunkt ist leider ausgebucht. Bitte wähle einen anderen.",
    turnstileFailed:
      "Sicherheitsüberprüfung fehlgeschlagen. Bitte versuche es erneut.",
    reservationExpired:
      "Diese Reservierung kann nicht mehr geändert oder storniert werden.",
    noContactMethod: "Bitte gib mindestens eine E-Mail oder Telefonnummer an",
    areaDisabled: "Bereich wird derzeit nicht angeboten",
    outsideAdvanceWindow: "Datum liegt außerhalb des Buchungszeitraums",
    outsideSameDayCutoff:
      "Reservierungen für heute sind nicht mehr möglich. Bitte wähle ein anderes Datum.",
    outsideSameDayCutoffSelfService:
      "Der gewählte Zeitpunkt liegt außerhalb des Buchungszeitraums.",
    network: "Verbindung fehlgeschlagen. Bitte versuche es erneut.",
    invalidInput: "Bitte überprüfe deine Eingaben.",
  },
  // Phase 7 plan 07-06: self-service signup + onboarding wizard
  // strings. The DE/EN bundles must keep parity — see
  // apps/web/test/signup.test.tsx (i18n parity assertion).
  signup: {
    title: "Restaurant registrieren",
    subtitle:
      "Erstellen Sie in wenigen Minuten Ihr eigenes Gastio-Mandanten-Konto.",
    slug: "Wunsch-Slug (z.B. acme-bistro)",
    slugHint:
      "Wird Teil Ihrer Subdomain ({{slug}}.{{baseDomain}}). Kleinbuchstaben, Zahlen und Bindestriche, 3–40 Zeichen.",
    restaurantName: "Restaurantname",
    email: "E-Mail",
    address: "Adresse",
    postalCode: "PLZ",
    city: "Stadt",
    consent: "Ich stimme der Verarbeitung meiner Daten zur Kontoerstellung zu.",
    submit: "Registrierung anfordern",
    submitting: "Wird gesendet…",
    checkEmail:
      "Wir haben Ihnen einen Bestätigungslink an {{email}} gesendet. Bitte klicken Sie ihn innerhalb von 24 Stunden.",
    slugSuggestions: "Vorschläge",
    invalidInput:
      "Bitte überprüfen Sie Ihre Eingaben — der Slug muss 3–40 Zeichen lang sein und darf nur Kleinbuchstaben, Zahlen und Bindestriche enthalten.",
    slugTaken:
      "Dieser Slug ist bereits vergeben. Wählen Sie einen anderen oder verwenden Sie einen Vorschlag.",
    genericError:
      "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    adminPassword: "Administrator-Passwort",
    adminPasswordHint: "Mindestens 12 Zeichen.",
    adminPasswordConfirm: "Passwort wiederholen",
    adminPasswordMismatch: "Die Passwörter stimmen nicht überein.",
    adminPasswordTooShort: "Passwort muss mindestens 12 Zeichen lang sein.",
  },
  onboarding: {
    brand: "Onboarding",
    back: "Zurück",
    progressAria: "Onboarding-Fortschritt, Schritt {{current}} von {{total}}",
    step: {
      address: "Adresse",
      capacity: "Kapazität",
      hours: "Öffnungszeiten",
      review: "Übersicht",
    },
    addressTitle: "Ihre Adresse",
    addressStreet: "Straße und Hausnummer",
    addressPostalCode: "PLZ",
    addressCity: "Stadt",
    capacityTitle: "Ihre Standardkapazität",
    capacityTotalSeats: "Plätze pro Tag",
    capacityHelp: "Wie viele Plätze haben Sie pro Tag insgesamt zur Verfügung?",
    hoursTitle: "Ihre Öffnungszeiten",
    hoursHelp:
      "Tragen Sie pro Wochentag die Öffnungszeiten ein. Geschlossene Tage lassen Sie leer.",
    reviewTitle: "Bitte prüfen und bestätigen",
    reviewSummary: "Zusammenfassung",
    adminPasswordHint:
      "Legen Sie das Passwort fest, mit dem Sie sich gleich im Admin-Bereich anmelden.",
    submitting: "Wird gespeichert…",
    saveNext: "Speichern & weiter",
    activate: "Restaurant aktivieren",
    activated: "Restaurant aktiviert — Sie werden zum Login weitergeleitet.",
    requiredField: "Pflichtfeld",
    hoursInvalid: "Ungültige Uhrzeit (HH:mm).",
  },
  // Quick-Task 260920-u3p: public confirm-email-change deeplink
  // page (apps/web/src/pages/confirm-email-change/[token].tsx). The
  // page fires the mutation on mount, so the strings are the three
  // terminal states (pending / success / error).
  accountConfirm: {
    title: "E-Mail-Adresse wird bestätigt",
    pending: "Bestätigung wird verarbeitet. Bitte einen Moment Geduld …",
    successTitle: "E-Mail-Adresse aktualisiert",
    successBody:
      "Ihre Admin-E-Mail-Adresse ist jetzt {{email}}. Aus Sicherheitsgründen wurden alle aktiven Anmelde-Sitzungen beendet.",
    successHint:
      "Bitte melden Sie sich mit Ihrer neuen E-Mail-Adresse erneut an.",
    continue: "Zur Anmeldung",
    errorTitle: "Bestätigung nicht möglich",
    errorBody:
      "Der Bestätigungslink ist ungültig, abgelaufen oder wurde bereits verwendet. Bitte fordern Sie einen neuen Link an.",
    errorRateLimitTitle: "Zu viele Anfragen",
    errorRateLimitBody:
      "Sie haben in den letzten 24 Stunden zu viele Anfragen gestellt. Bitte versuchen Sie es später erneut.",
    backToLogin: "Zur Anmeldung",
  },
} as const;
